import styled from "styled-components";

const Container = styled.div`
    position: absolute;
    top: 245px;
    left: 15px;
    background: white;
    height: calc(100% - 300px);
    width: 300px;
    display: flex;
    flex-direction: column;
`;

export { Container };
